import { useState, useEffect } from 'react';
import { Spin, Result, Button } from 'antd';
import ArrivalSign from './ArrivalSign';
import { api } from '../../api';

/**
 * wxjk-med 嵌入页：到货签收
 * URL: /embed/arrival-sign?token=xxx (AES加密的cCusCode)
 * 无需登录，直接解密→自动登录→渲染页面
 */
export default function EmbedArrivalSign() {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const token = new URLSearchParams(window.location.search).get('token');
    if (!token) { setError('缺少 token 参数'); setLoading(false); return; }

    (async () => {
      try {
        const r = await fetch('/api/auth/wxjk-embed-login', {
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          body: new URLSearchParams({ token }),
        });
        const d = await r.json();
        if (!d.success) { setError(d.detail || '登录失败'); setLoading(false); return; }

        localStorage.setItem('ar_token', d.token);
        localStorage.setItem('ar_user', JSON.stringify(d.user));
        sessionStorage.setItem('embed_mode', '1');  // 嵌入式模式，全局隐藏侧栏
        setLoading(false);
      } catch (e) {
        setError('网络错误: ' + e.message);
        setLoading(false);
      }
    })();
  }, []);

  if (loading) {
    return <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}><Spin size="large" tip="正在加载..." /></div>;
  }
  if (error) {
    return <Result status="error" title="加载失败" subTitle={error} extra={<Button onClick={() => window.location.reload()}>重试</Button>} />;
  }

  return <ArrivalSign />;
}
